import { Component, computed, inject } from '@angular/core';
import { BootFallbackService, IBootFallbackCompany } from '@core/ssr/boot-fallback.service';
import { whatsappPhone, whatsappUrl } from '@shared/utils/whatsapp.utils';

/**
 * Bloco de contato do nível B (plano 3, Fase 4b; Anexo J.2.8). O SSR o desenha sempre, escondido (style="display: none").
 * Só aparece quando o vigia de boot do src/index.html põe agj-boot-failed no <html> (o app não subiu em 12 s,
 * caso do iPhone 6). O CSS fica inline no index.html, sem gap em flex, inset, dvh nem :is() (roda no iOS 12).
 *
 * ngSkipHydration: no navegador o bloco é refeito do zero e não precisa bater com o HTML do servidor
 * (no cliente o serviço não tem a empresa; ela só é buscada no SSR).
 */
@Component({
  selector: 'agj-boot-fallback',
  templateUrl: './boot-fallback.component.html',
  host: { ngSkipHydration: 'true' }
})
export class BootFallbackComponent {
  private readonly fallback: BootFallbackService = inject(BootFallbackService);

  public company = computed<IBootFallbackCompany | null>(() => this.fallback.company());
  public whatsappHref = computed<string>(() => {
    const company: IBootFallbackCompany | null = this.company();
    return company ? whatsappUrl(company.phone, `Olá, ${company.name}! Quero marcar um horário.`) : '';
  });
  public phoneHref = computed<string>(() => {
    const company: IBootFallbackCompany | null = this.company();
    return company?.phone ? `tel:+${whatsappPhone(company.phone)}` : '';
  });
}
